import type { TripPlannerChat } from 'tripPlanner/api/types'

export const getChatLastActivityTimestamp = (chat: TripPlannerChat): string => {
  return chat.updatedAt ?? chat.createdAt
}
